import { useState, useEffect } from 'react';

export default function useFirstTime(touched: boolean, deps: any[] = []) {
  const [notTouched, setNotTouched] = useState(true);

  useEffect(() => {
    if (!notTouched) return;
    if (touched) setNotTouched(false);
  }, deps);

  return notTouched;
}
